import _ from "lodash";

import { URLS } from "config/urls";
import theme from "theme";
import { colors } from "theme/palette";
import { format, FORMATS, parseJSON } from "utils/datetime";
import { reverse } from "utils/urls";

import Card, { CardActionArea } from "components/Card";
import Link from "components/Link";
import Stack from "components/Stack";
import Text from "components/Text";

import MemoESignatureTrackingProcessTag from "entities/Memo/components/Sections/MemoESignatureDrawer/components/MemoESignatureProcessTrackingTag";
import { IMemoSignatureData } from "entities/Memo/sdk";

export interface IMemoSignatureBox {
  memoSignature: IMemoSignatureData;
}

const MemoSignatureBox = ({ memoSignature }: IMemoSignatureBox) => (
  <Link
    to={
      memoSignature.is_completed
        ? reverse(URLS.DEAL_MEMO_SIGNATURE_PROCESS_COMPLETED, {
            dealId: memoSignature.deal.id,
            memoId: memoSignature.memo.id,
          })
        : reverse(URLS.DEAL_MEMO_SIGNATURE, {
            dealId: memoSignature.deal.id,
            memoId: memoSignature.memo.id,
            roleId: memoSignature.role.id,
          })
    }
  >
    <Card
      sx={{
        flexDirection: "column",
        borderRadius: 3,
        height: "100%",
        boxShadow: `0 4px 8px 0 ${colors.gray20}`,
        transition: "boxShadow 0 linear",
        "&:hover": {
          boxShadow: `0 4px 8px 0 ${colors.gray60}`,
        },
      }}
      data-testid="checklist-card"
    >
      <CardActionArea
        sx={{
          height: "100%",
          display: "flex",
          flexDirection: "column",
          alignItems: "flex-start",
          justifyContent: "flex-start",
          padding: theme.spacing(1, 2),
        }}
        data-testid="checklist-card-content"
      >
        <Stack>
          <MemoESignatureTrackingProcessTag
            status={memoSignature.status}
            isCompleted={memoSignature.is_completed}
          />
          <Text
            marginTop={0.2}
            fontSize={16}
            fontWeight={800}
            variant="text2"
            data-testid="checklist-name"
          >
            {memoSignature.memo.name}
          </Text>
          <Text
            fontSize={15}
            fontWeight={400}
            variant="text2"
            data-testid="checklist-owner-company-name"
          >
            {memoSignature.company_name}
          </Text>
        </Stack>
        <Stack
          marginTop={1.5}
          sx={{
            backgroundColor: colors.blue20,
            borderRadius: "4px",
            width: "fit-content",
          }}
          padding={theme.spacing(0.4, 0.8)}
        >
          <Text
            fontWeight={700}
            fontSize={13}
            variant="text2"
            data-testid="checklist-deal-name"
          >
            {memoSignature.deal.name}
          </Text>
        </Stack>
        <Text variant="text4" color={colors.gray60} marginTop={0.6}>
          {!_.isNil(memoSignature.signed_at)
            ? `Signed on ${format(parseJSON(memoSignature.signed_at), FORMATS.FRONTEND.DATE)}`
            : `Sent on ${format(parseJSON(memoSignature.sent_at), FORMATS.FRONTEND.DATE)}`}{" "}
        </Text>
      </CardActionArea>
    </Card>
  </Link>
);

export default MemoSignatureBox;
